<template>
  <div
    class="grey position-relative slides slop"
    :class="$route.path === '/' ? 'slides-fade' : ''"
  >
    <LoadingWidget v-if="loading" />

    <keep-alive>
      <transition name="fade">
        <div v-if="!loading && items.length" class="position-relative">
          <hooper-container
            class="slides-container"
            style="height: auto"
            ref="carousel"
            :autoPlay="true"
            :playSpeed="8000"
            :wheelControl="false"
            :mouseDrag="items.length > 1"
            :touchDrag="items.length > 1"
            :infiniteScroll="items.length > 1"
            @slide="updateCarousel"
          >
            <hooper-slide
              class="item"
              v-for="(
                { img_desktop, img_mobile, link, target }, keySlide
              ) in items"
              :key="keySlide"
            >
              <a
                v-if="link"
                :href="link"
                :target="target ? `_blank` : `_self`"
                rel="noopener noreferrer"
              >
                <img
                  :src="files + (xs && img_mobile ? img_mobile : img_desktop)"
                  class="d-block item-img"
                  width="100%"
                />
              </a>
              <img
                v-if="!link"
                :src="files + (xs && img_mobile ? img_mobile : img_desktop)"
                class="d-block item-img"
                width="100%"
              />
            </hooper-slide>
          </hooper-container>

          <div
            v-if="items.length > 1"
            class="d-flex justify-space-between px-3 px-md-4 px-lg-5 slides-nav"
          >
            <a
              class="
                d-flex
                align-center
                justify-center
                elevation-2
                pr-1
                slides-nav-item
              "
              @click.prevent="slidePrev"
            >
              <v-icon color="primary" :size="xs ? 20 : 30">
                fa-angle-left
              </v-icon>
            </a>
            <a
              class="
                d-flex
                align-center
                justify-center
                elevation-2
                pl-1
                slides-nav-item
              "
              @click.prevent="slideNext"
            >
              <v-icon color="primary" :size="xs ? 20 : 30">
                fa-angle-right
              </v-icon>
            </a>
          </div>
        </div>
      </transition>
    </keep-alive>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";

export default {
  data: () => ({
    carouselData: 0,
  }),
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.slides-fade {
  &:after {
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0) 150px
    );
    bottom: 0;
    content: "";
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;

    @media screen and (max-width: 960px) {
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(0, 0, 0, 0) 80px
      );
    }
  }
}
.slides-container::v-deep {
  ul,
  ol {
    padding: 0 !important;
  }
}

.slides {
  aspect-ratio: 1920 / 680;

  @media screen and (max-width: 960px) {
    aspect-ratio: 960 / 960;
  }

  .item {
    &-img {
      aspect-ratio: 1920 / 680;
      object-fit: cover;
      -o-object-fit: cover;

      @media screen and (max-width: 960px) {
        aspect-ratio: 960 / 960;
      }
    }
  }

  &-nav {
    height: 0;
    left: 0;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 100%;

    @media screen and (max-width: 600px) {
      margin-top: -20px;
    }

    &-item {
      background-color: #ffffff;
      border-radius: 50%;
      height: 50px;
      width: 50px;
      @media screen and (max-width: 600px) {
        height: 40px;
        width: 40px;
      }
    }
  }
}
</style>
